import dayjs from "dayjs"
import { ReactNode } from "react"
import { ProgramTypeOption } from "../../types.graphql"
import { cn } from "@utils/tw"
import { Link } from "eddev/routing"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { PROGRAM_TYPE_COLOR } from "@utils/program-colors"

type Props = {
  startDate: dayjs.Dayjs
  endDate?: dayjs.Dayjs
  typeLabel: ReactNode
  title: ReactNode
  description: ReactNode
  tags?: ReactNode
  programType?: ProgramTypeOption
  url: string
  target?: string
  image?: {
    srcSet?: string | null
    aspect?: number | null
  }
}

/**
 * Used by Year-Round calendar
 */

export function LargeEventRow(props: Props) {
  const month = props.startDate.format("MMMM")
  const day = props.startDate.format("D")
  const endDay = props.endDate?.format("D")

  return (
    <Link href={props.url} target={props.target} className="flex-1 flex flex-col md:flex-row">
      {/* Left side */}
      <div className="flex flex-col py-4 items-center justify-center gap-3 md:w-cols-2 bg-black text-white">
        <div className="type-label-s-light">{month}</div>
        <div className="type-title-xl max-md:-mb-2">
          {day}
          {endDay ? "-" + endDay : ""}
        </div>
      </div>
      {/* Right side */}
      <div
        className={cn(
          "flex gap-x-4 justify-between p-4 flex-1 gap-4 bg-grey8 flex-col md:flex-row",
          props.programType && PROGRAM_TYPE_COLOR[props.programType],
        )}
      >
        <div className="flex gap-y-5 flex-col justify-between h-full text-pretty">
          {/* Info/Top */}
          <div className="flex flex-col">
            {props.typeLabel && <div className="type-label-xs mb-4">{props.typeLabel}</div>}
            <div className="type-title-l mb-3 max-w-[15em] text-balance">{props.title}</div>
            {props.description && <div className="type-body-s mb-4">{props.description}</div>}
          </div>
          {/* Tags/Bottom */}
          <div className="flex flex-row gap-3 items-center flex-wrap">{props.tags}</div>
        </div>
        {!!props.image && (
          <div className="h-[50vw] md:h-auto md:w-cols-3 flex flex-row gap-2">
            <img srcSet={props.image.srcSet!} className="flex-1 w-[90%] object-cover object-center" />
            <img srcSet={props.image.srcSet!} className="flex-1 w-[1%] object-cover object-[75%_center]" />
          </div>
        )}
      </div>
    </Link>
  )
}
